import { useForm, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { IdentityProvidersMessages } from '../../IdentityProviders.messages';
import { yupResolver } from '@hookform/resolvers/yup';
import { externalIdpLogoutConfigSchema } from 'pages/IdentityProviders/schema/identityProviderSchema';
import { OidcAuthFlow } from '../../../../api-client';

type UseUpdateOidcProviderForm = () => UseFormReturn;

export const useUpdateOidcProviderForm: UseUpdateOidcProviderForm = () => {
  const intl = useIntl();
  const updateIdentityProviderValidationSchema = yup.object().shape({
    name: yup.string().required(intl.formatMessage(IdentityProvidersMessages.nameRequiredError)),
    clientId: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.clientIdRequiredError)),
    issuer: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.issuerRequiredError))
      .url(intl.formatMessage(IdentityProvidersMessages.issuerUrlValidationError)),
    externalIdField: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.externalIdRequiredError))
      .oneOf(['Uid', 'Email', 'PhoneNumber']),
    externalIdpLogoutConfig: externalIdpLogoutConfigSchema,
    prompt: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.promptRequiredError))
      .matches(
        /(none|login|consent|select_account)/,
        'Prompt must equal none, login, consent or select_account',
      ),
    flow: yup
      .string()
      .required('Flow is required')
      .oneOf([OidcAuthFlow.Implicit, OidcAuthFlow.Code]),
    originalFlow: yup.string().oneOf([OidcAuthFlow.Implicit, OidcAuthFlow.Code]).notRequired(),
    usePKCE: yup.boolean(),
    clientSecret: yup.string().when(['flow', 'originalFlow'], {
      is: (flow: OidcAuthFlow, originalFlow: OidcAuthFlow) =>
        flow === OidcAuthFlow.Code && originalFlow === OidcAuthFlow.Implicit,
      then: (schema) => schema.required('Client secret is required when flow is changed to Code'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  return useForm({
    resolver: yupResolver(updateIdentityProviderValidationSchema),
    mode: 'onChange',
  });
};
